import React from 'react'
import { useSelector } from 'react-redux'
import ComparatorIntro from '../../containers/ComparatorIntro/ComparatorIntro.container'
import ComparatorTradedAmounts from '../../containers/ComparatorTradedAmounts/ComparatorTradedAmounts.container'
import ComparatorBuyingModalities from '../../containers/ComparatorBuyingModalities/ComparatorBuyingModalities.container'
import ComparatorBiddings from '../../containers/ComparatorBiddings/ComparatorBiddings.container'
import ComparatorTradedBy from '../../containers/ComparatorTradedBy/ComparatorTradedBy.container'
import ComparatorProviders from '../../containers/ComparatorProviders/ComparatorProviders.container'

/**
 * Comparator's Container
 */
const Comparator = () => {
  const { latestUpdate } = useSelector(state => state.topNavbar)
  const {
    data: { firstEntity, secondEntity }
  } = useSelector(state => state.comparator)

  return (
    <>
      {firstEntity && secondEntity ? (
        <>
          <ComparatorIntro firstEntity={firstEntity} secondEntity={secondEntity} />
          <ComparatorTradedAmounts firstEntity={firstEntity} secondEntity={secondEntity} latestUpdate={latestUpdate} />
          <ComparatorBuyingModalities
            firstEntity={firstEntity}
            secondEntity={secondEntity}
            latestUpdate={latestUpdate}
          />
          <ComparatorBiddings firstEntity={firstEntity} secondEntity={secondEntity} latestUpdate={latestUpdate} />
          <ComparatorTradedBy firstEntity={firstEntity} secondEntity={secondEntity} latestUpdate={latestUpdate} />
          <ComparatorProviders firstEntity={firstEntity} secondEntity={secondEntity} latestUpdate={latestUpdate} />
        </>
      ) : null}
    </>
  )
}

export default Comparator
